// src/components/register/RegistrationWizard/index.js
import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useRegistration } from "../../../context/RegistrationContext";
import Message from "../../LeftBanner";
import BasicDetailsStep from "./Steps/BasicDetailsStep";
import AccountCreationStep from "./Steps/AccountCreationStep";
import UserTypeStep from "./Steps/UserTypeStep";
import PersonalDetailsStep from "./Steps/PersonalDetailsStep";
import EducationalDetailsStep from "./Steps/EducationalDetailsStep";
import ProgressBar from "./ProgressBar";
import "./RegistrationWizard.css";
import { useLoader } from "../../../context/LoaderContext";

const RegistrationWizard = () => {
  // Add these logs at the top of RegistrationWizard component
  const navigate = useNavigate();
  const { setIsLoading } = useLoader();
  const {
    currentStep,
    totalSteps,
    userType,
    educationLevel,
    isEmailVerified,
    isCompleted,
  } = useRegistration();
  console.log("Current user type:", userType);
  console.log("Current education level:", educationLevel);
  console.log(
    "showEducationalDetails:",
    userType === "Students" && educationLevel !== ""
  );
  console.log("🔄 Current Step in UI:", currentStep);

  // If registration is completed, redirect to login
  useEffect(() => {
    if (isCompleted) {
      navigate("/login");
    }
  }, [isCompleted, navigate]);

  // Determine if educational details step should be shown
  const showEducationalDetails =
    userType === "Students" && educationLevel !== "";

  // Render the current step
  const renderStep = () => {
    switch (currentStep) {
      case 1:
        return <BasicDetailsStep />;
      case 2:
        return <AccountCreationStep />;
      case 3:
        return <UserTypeStep />;
      case 4:
        return <PersonalDetailsStep />;
      case 5:
        console.log("Rendering EducationalDetailsStep");
        return showEducationalDetails ? (
          <EducationalDetailsStep />
        ) : (
          <div>Skipping educational step</div>
        );
      default:
        return <BasicDetailsStep />;
    }
  };

  return (
    <div className="registration-wizard-wrapper">
      <div className="message-banner">
        <Message />
      </div>

      <div className="registration-form-container">
        <div className="registration-card">
          <ProgressBar currentStep={currentStep} totalSteps={totalSteps} />

          {/* Email verification warning if not verified */}
          {currentStep > 1 && !isEmailVerified && (
            <div className="verification-warning">
              Please verify your email to proceed with registration
            </div>
          )}

          {/* Render the current step */}
          {renderStep()}
        </div>
      </div>
    </div>
  );
};

export default RegistrationWizard;
